import styled from 'styled-components';
import { ExchangeIcon } from '../../assets';
import Button from '../../button/Button';
import Checkbox from '../../checkbox/Checkbox';
import CurrencyInput from '../../currency-input/CurrencyInput';
import Input from '../../input/Input';
import { TransparentButton } from '../../transparent-button/TransparentButton';
import Typography from '../../typography/Typography';
export const TabsContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  border-radius: 3rem 3rem 2rem 2rem;
`;
export const CustomTypography = styled(Typography) `
  font-size: 1.2rem;
  line-height: 1.8rem;
`;
export const TextWrapper = styled.div `
  margin: 1rem 0;
  width: 100%;
  text-align: center;
  padding-bottom: 1rem;
`;
export const CustomCurrencyInput = styled(CurrencyInput) `
  border-bottom: none;
`;
export const CustomButton = styled(Button) `
  margin-top: 2.5rem;
`;
export const InputText = styled(Typography) `
  font-size: 1.6rem;
  line-height: 2.4rem;
`;
export const AdditionalInfoWrapper = styled.div `
  padding: 2rem 5.1rem 3.6rem;
`;
export const CalculatorWrapper = styled.div `
  max-width: 70rem;

  margin: 0 auto;
`;
export const AdditionalInfoDesc = styled(Typography) `
  font-size: 1.4rem;
  line-height: 2rem;
`;
export const AdiditionalInfoButton = styled(Button) `
  width: 100%;
`;
export const CustomInput = styled(Input) `
  margin: 1rem 0;
`;
export const SwapCalculatorBackground = styled.div `
  display: flex;

  padding: 2rem 2.2rem;

  //TODO diff border radius
  border-radius: ${({ theme }) => theme.borderRadius.highM};

  //TODO should we leave gradient like this
  background ${({ backgroundColor }) => backgroundColor};

  backdrop-filter: blur(32px);

  ${({ theme }) => theme.media.tabletL `
      padding: 2rem;

      border: 1px solid rgba(160, 170, 206, 0.32);
  `}
`;
export const SwapCalculatorContainer = styled.div `
  width: 100%;

  border-radius: ${({ theme }) => theme.borderRadius.highM};

  ${({ theme }) => theme.media.tabletL `
      padding: 2rem 1.8rem 2.4rem;
  
      background-color:${theme.colors.surface.default}
    `}
`;
export const CalculatorMainWrapper = styled.div `
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.media.tabletL `
      flex-direction: row;
      padding-bottom: 2.4rem;
    `}
`;
export const InputsWrapper = styled.div `
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;

  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.highM};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.highM};
  z-index: ${({ theme }) => theme.zIndex.medium};
  ${({ theme }) => theme.media.tabletL `
      filter: none;
    `}
`;
export const RateTypeWrapper = styled.div `
  ${({ theme }) => theme.media.tabletL `
      width: 40%;
  
      margin-left: 1.6rem;
    `}
`;
export const ChooseRateWrapper = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const TermsAndConditionsWrapper = styled.div `
  display: inline-block;
  cursor: pointer;
`;
export const RateTypeBody = styled.div `
  display: flex;
  flex: 1;
  justify-content: space-between;

  margin-top: -1rem;

  border-top: none;

  border-radius: ${({ theme }) => theme.borderRadius.highM};

  background-color: ${({ theme }) => theme.colors.surface.default};

  ${({ theme }) => theme.media.tabletL `
      display: flex;
      flex-direction: column;
  
      margin-top: 0;
      padding: unset;
  
      border: unset;
  
    `};
`;
export const CustomCheckbox = styled(Checkbox) `
  display: none;

  ${({ theme }) => theme.media.tabletL `
      display: flex;
    `}
`;
export const AddressInputWrapper = styled.div `
  margin-bottom: 1.8rem;

  ${({ theme }) => theme.media.tabletL `
      margin-bottom: 2rem;
    `}
`;
export const InputTextWrapper = styled.div `
  margin-bottom: 0.8rem;
`;
export const RateOption = styled(TransparentButton) `
  display: flex;
  justify-content: center;

  width: 50%;

  padding: 2.8rem 0 1.8rem;

  border: 1px solid
    ${({ theme, isActive }) => isActive
    ? theme.colors.interactive.brandColor
    : theme.colors.borders.default};

  //TODO should we leave rgba?
  background: ${({ isActive }) => isActive ? 'rgba(80, 107, 249, 0.10)' : 'initial'};
  &:first-child {
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius.highM};
    border-right: none;
  }

  &:last-child {
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius.highM};
    border-left-color: ${({ theme }) => theme.colors.interactive.brandColor};
  }

  ${({ theme, isActive }) => theme.media.tabletL `
      justify-content: space-between;
      align-items: center;
  
      width: initial;
  
      padding: 0.8rem;
  
     
      &:first-child {
      border-right: 1px solid
    ${(isActive
    ? theme.colors.interactive.brandColor
    : theme.colors.borders.default)};
      border-radius: unset;
        border-top-left-radius: ${theme.borderRadius.high};
        border-top-right-radius: ${theme.borderRadius.high};
        padding: 2rem 1.5rem;
      }
      &:last-child {
         border-radius: unset;
         border-bottom-left-radius: ${theme.borderRadius.high};
        border-bottom-right-radius: ${theme.borderRadius.high};
        padding: 2rem 1.5rem;
        border-left-color:  ${(isActive
    ? theme.colors.interactive.brandColor
    : theme.colors.borders.default)};;
      }
  
      background: ${(isActive
    ? theme.colors.interactive.secondaryHover
    : 'initial')};
  
  
    `}
`;
export const TermsAndConditionsTypography = styled(Typography) `
  font-size: 1.2rem;
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.interactive.brandColor};
`;
export const DisclaimerText = styled(Typography) `
  font-size: 1.2rem;
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.text.default};
`;
export const DisclaimerTextContainer = styled.div `
  margin-top: 1.8rem;
  ${({ theme }) => theme.media.tabletL `
    display: flex;
    justify-content: center;
    gap: 0.2rem;
  `}
`;
export const RateTypeText = styled(Typography) `
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
export const RateTypeTextContainer = styled.div `
  display: flex;
  justify-content: center;
  margin: 1rem auto;
  ${({ theme }) => theme.media.tabletL ` 
    display: none;
  `};
`;
export const RateOptionContent = styled.div `
  display: flex;
  flex-direction: column;
  text-align: left;
`;
export const TitleWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 1rem;

  svg {
    width: 1.4rem;
    height: 1.4rem;
  }
`;
export const RateOptionTitle = styled(Typography) `
  max-width: min-content;
  ${({ theme }) => theme.media.mobileL `
      max-width: unset;
  `}
`;
export const Description = styled(Typography) `
  display: none;

  margin-top: 0.2rem;

  ${({ theme }) => theme.media.tabletL `
      display: flex;
  `}
`;
export const ExchangeIconWrapper = styled.div `
  position: absolute;
  background-color: ${({ theme, isReverseTradePossible }) => isReverseTradePossible
    ? theme.colors.interactive.brandColor
    : theme.colors.interactive.brandColorDisabled};
  height: 4.4rem;
  width: 4.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${({ theme }) => theme.zIndex.low};
  top: 50%;

  transform: translateY(-50%);

  transition: 0.5s;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  cursor: ${({ isReverseTradePossible }) => isReverseTradePossible ? 'pointer' : 'not-allowed'};
  ${({ theme }) => theme.media.tabletL `
      height: 3.4rem;
      width: 3.4rem;
  `};
`;
export const CustomExchangeIcon = styled(ExchangeIcon) `
  ${({ isReverseTradePossible }) => !isReverseTradePossible && 'opacity : 0.2;'};
`;
export const TimeSelectionButtonsWrapper = styled.div `
  display: flex;
  gap: 1.2rem;
  margin-top: 1.2rem;
`;
export const CustomTimerButton = styled(Button) `
  border-color: ${({ isActive, theme }) => isActive ? theme.colors.interactive.brandColor : 'none'};
  background-color: ${({ theme, isActive }) => isActive ? theme.colors.interactive.secondary : 'none'};
`;
//# sourceMappingURL=styles.js.map